// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"345":"58bc348b","649":"ca793640","870":"7dda41b2"}[chunkId] + ".chunk.js");